export * as plugins from '@wix/auto_sdk_site-plugins_plugins/meta';
